// File: /js/pages/contenu-catalog.js
//
// The public "Contenu" vignette catalog — CLIENT-side filtering over the
// server-rendered card grid (VignetteCatalogRenderer): niveau segments ∧
// spécialité select ∧ objectif-SSP select (matches ssp_req OR ssp_compl,
// via each card's data-ssp id list) ∧ title search, with a live count + an
// empty message. The published set is small; revisit server-side filtering
// when it isn't.

function setupCatalog(root) {
  const cards = Array.from(root.querySelectorAll('[data-vcat-card]'));
  if (cards.length === 0) return;

  const segButtons = Array.from(root.querySelectorAll('.vcat__seg-btn'));
  const specSelect = root.querySelector('[data-vcat-spec]');
  const sspSelect = root.querySelector('[data-vcat-ssp]');
  const searchInput = root.querySelector('[data-vcat-search]');
  const countEl = root.querySelector('[data-vcat-count]');
  const emptyEl = root.querySelector('[data-vcat-empty]');

  let level = '';

  function apply() {
    const spec = specSelect instanceof HTMLSelectElement ? specSelect.value : '';
    const ssp = sspSelect instanceof HTMLSelectElement ? sspSelect.value : '';
    const query = (searchInput instanceof HTMLInputElement ? searchInput.value : '')
      .toLowerCase().trim();

    let shown = 0;
    for (const card of cards) {
      const ok = (!level || card.dataset.level === level)
        && (!spec || card.dataset.spec === spec)
        && (!ssp || (card.dataset.ssp || '').split(',').includes(ssp))
        && (!query || (card.dataset.search || '').includes(query));
      card.hidden = !ok;
      if (ok) shown++;
    }

    if (emptyEl) emptyEl.hidden = shown !== 0;
    if (countEl) {
      const tpl = shown === 1 ? countEl.dataset.one : countEl.dataset.many;
      if (tpl) countEl.textContent = tpl.replace('{n}', String(shown));
    }
  }

  for (const btn of segButtons) {
    btn.addEventListener('click', () => {
      level = btn.dataset.vcatLevel || '';
      for (const b of segButtons) {
        b.classList.toggle('is-on', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      }
      apply();
    });
  }
  if (specSelect) specSelect.addEventListener('change', apply);
  if (sspSelect) sspSelect.addEventListener('change', apply);
  if (searchInput) searchInput.addEventListener('input', apply);
}

function setup() {
  document.querySelectorAll('.vcat').forEach(setupCatalog);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setup);
} else {
  setup();
}
